import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import coreService from "@/utils/axios/core-service";
import { API_ENDPOINTS, RESPONSE_STATUSES } from "@/constants/api-endpoints";
import { MARKET_PLACES } from "@/constants/app";

// 🚀 Fetch all eBay item condition data
export const fetchEbayItemConditionData = createAsyncThunk(
  "ebayItemConditions/fetchAll",
  async ({ page = 0, size = 5 } = {}, thunkAPI) => {
    try {
      const response = await coreService.post(
        `${API_ENDPOINTS.ADMIN.SETTINGS.EBAY.ITEM_CONDITION.GET_ALL}?page=${page}&size=${size}&sort=id,asc`,
        [
          {
            fieldName: "marketPlace",
            fieldValue: MARKET_PLACES.EBAY,
            searchOperator: "LIKE",
          },
        ]
      );

      if (response.data?.status == RESPONSE_STATUSES.SUCCESS) {
        return response.data.data.content || [];
      }

      return thunkAPI.rejectWithValue("Unexpected response from server");
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.message || "API error");
    }
  }
);
export const submitEbayItemCondition = createAsyncThunk(
  "ebayItemConditions/submit",
  async ({ payload, page, size, t }, thunkAPI) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await coreService.post(
          API_ENDPOINTS.ADMIN.SETTINGS.EBAY.ITEM_CONDITION.CREATE,
          payload
        );

        if (response.data.status == RESPONSE_STATUSES.CREATED) {
          // 🔥 Refetch after success
          thunkAPI.dispatch(fetchEbayItemConditionData({ page, size }));

          resolve(t("itemConditionUpdatedSuccessfully"));
        } else {
          reject(t("failedToUpdatedItemCondition"));
        }
      } catch (err) {
        reject(err?.message || "Unexpected server error");
      }
    });
  }
);
// ⭐ Slice
const ebayItemConditionSlice = createSlice({
  name: "ebayItemCondition",
  initialState: {
    ebayItemConditionData: [],
    ebayItemConditionLoading: false,
    ebayItemConditionError: null,
    submitLoading: false,
  },

  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(fetchEbayItemConditionData.pending, (state) => {
        state.ebayItemConditionLoading = true;
        state.ebayItemConditionError = null;
      })
      .addCase(fetchEbayItemConditionData.fulfilled, (state, action) => {
        state.ebayItemConditionLoading = false;
        state.ebayItemConditionData = action.payload;
      })
      .addCase(fetchEbayItemConditionData.rejected, (state, action) => {
        state.ebayItemConditionLoading = false;
        state.ebayItemConditionError = action.payload;
        state.ebayItemConditionData = [];
      })
      // SUBMIT
      .addCase(submitEbayItemCondition.pending, (state) => {
        state.submitLoading = true;
      })
      .addCase(submitEbayItemCondition.fulfilled, (state) => {
        state.submitLoading = false;
      })
      .addCase(submitEbayItemCondition.rejected, (state) => {
        state.submitLoading = false;
      });
  },
});

export default ebayItemConditionSlice.reducer;
